import { api } from "@/lib/axios";

export default function registerAction({
  leadId,
  action,
}: {
  leadId: string;
  action: string;
}) {
  return api.put(`leads/action/${leadId}`, {
    action
  });
}
